export class TempUser {
  id: number = 0;
  name: string = '';
  email: string = '';
  password: string = '';
  phoneNumber: string = '';
  moneyType: number = 0;
  lenguajeType: number = 0;
  invitatedUser: boolean = false;
  status: boolean = false;
  verificated: boolean = false;
  code: number = 0;

  constructor(data?: Partial<TempUser>) {
    if (data) {
      Object.assign(this, data);
    }
  }
}

export interface TemporalUserVerificationRequest {
  Correo: string;
  OTP: string;
}
